import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../../shared/modules/shared/shared.module';
import { InvitationListComponent } from '../../components/invitation-list/invitation-list.component';
import { OrganisationInvitationDialogComponent } from '../../components/organisation-invitation-dialog/organisation-invitation-dialog.component';
import { OrganisationInvitationValidationComponent } from '../../components/organisation-invitation-validation/organisation-invitation-validation.component';
import { OrganisationInvitationService } from '../../services/organisation-invitation/organisation-invitation.service';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    OrganisationInvitationDialogComponent,
    OrganisationInvitationValidationComponent,
    InvitationListComponent,
  ],
  providers: [OrganisationInvitationService],
  exports: [
    OrganisationInvitationDialogComponent,
    OrganisationInvitationValidationComponent,
    InvitationListComponent,
  ],
})
export class OrganisationInvitationModule {}
